import { Component, OnInit, ViewEncapsulation } from '@angular/core';

// This component is used only on the server. Since the server does not inline styles.scss we must use this
// component that has view encapsulation none to make these global styles available inline in the server rendered view
// These styles will be removed during the client-server transition and this component is not included in the client render.
@Component({
  selector: 'app-global-style-loader',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './global-style-loader.component.html',
  styleUrls: ['./global-style-loader.component.scss']
})
export class GlobalStyleLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
